<template>
	<v-row class="pb-offset pt-4">
		<v-col class="pa-0 px-4" cols="12">
			<v-card elevation="1" class="background-2 round-card">
				<v-card-title class="px-3 py-2"><p class="pl-2 pl-xl-3">Connessione ad AISA</p></v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-row>
						<v-col cols="12" md="6">
							<v-text-field label="Chiave API" v-model="aisa.options.api_key" type="password" hint="Da Impostazioni assistente in AISA (aisa_ak_...)" persistent-hint outlined dense></v-text-field>
						</v-col>
						<v-col cols="12" md="6" class="d-flex align-center">
							<v-switch inset v-model="aisa.active" label="Integrazione attiva" color="primary"></v-switch>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field label="Id organizzazione" v-model="aisa.options.organization_id" hint="Dalla URL della dashboard: /orgs/<id>/" persistent-hint outlined dense></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field label="Id assistente" v-model="aisa.options.assistant_id" hint="Dalla URL della dashboard: /assistants/<id>/" persistent-hint outlined dense></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="pa-3">
					<v-btn text color="primary" :disabled="!caricato" :loading="verificando" @click="verifica">Verifica connessione</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary" :disabled="!caricato" :loading="salvando" @click="salva">Salva configurazione</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>

		<v-col class="pa-0 px-4 mt-4" cols="12">
			<v-card elevation="1" class="background-2 round-card">
				<v-card-title class="px-3 py-2"><p class="pl-2 pl-xl-3">Webhook</p></v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<p>Da incollare in AISA, nel comportamento, sotto "Invia gli aggiornamenti al CRM".</p>
					<v-row>
						<v-col cols="12" md="6">
							<v-text-field label="URL" :value="webhookUrl" readonly outlined dense append-icon="mdi-content-copy" @click:append="copia(webhookUrl)"></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field label="Token" :value="aisa.options.webhook_token || ''" readonly outlined dense type="password" append-icon="mdi-content-copy" @click:append="copia(aisa.options.webhook_token)" hint="Generandone uno nuovo quello vecchio smette di funzionare" persistent-hint></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field label="URL di inoltro (facoltativo)" v-model="aisa.options.forward_url" hint="Ogni evento viene inoltrato anche qui, per esempio a un flusso n8n" persistent-hint outlined dense></v-text-field>
						</v-col>
						<v-col cols="12" md="3">
							<v-text-field label="Token di inoltro" v-model="aisa.options.forward_token" type="password" hint="Inviato come X-API-Token" persistent-hint outlined dense></v-text-field>
						</v-col>
						<v-col cols="12" md="3">
							<v-text-field label="Giorni di blocco reinvio" v-model.number="aisa.options.blocco_reinvio_giorni" type="number" min="0" max="90" hint="0 disattiva il blocco" persistent-hint outlined dense></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="pa-3">
					<v-btn text color="primary" :disabled="!caricato" :loading="generando" @click="generaToken">{{ aisa.options.webhook_token ? 'Rigenera token' : 'Genera token' }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>

		<v-col class="pa-0 px-4 mt-4" cols="12">
			<v-card elevation="1" class="background-2 round-card">
				<v-card-title class="px-3 py-2"><p class="pl-2 pl-xl-3">Fonti AISA</p></v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<p>Ogni fonte AISA che accetta contatti diventa una coda in Call center. La sincronizzazione parte anche da sola ogni ora.</p>
					<v-simple-table v-if="code.length" dense class="background-2">
						<thead><tr><th>Coda</th><th>Tipo</th><th>Stato</th></tr></thead>
						<tbody>
							<tr v-for="coda in code" :key="coda.id">
								<td><router-link :to="'/callcenter/callqueues/' + coda.id">{{ coda.name }}</router-link></td>
								<td>{{ tipoFonte(coda.kind) }}</td>
								<td>
									<v-chip v-if="coda.disponibile" x-small color="success" outlined>Collegata</v-chip>
									<v-chip v-else x-small color="error" outlined>Fonte non più presente in AISA</v-chip>
								</td>
							</tr>
						</tbody>
					</v-simple-table>
					<p v-else class="caption">Nessuna coda AISA: salva la configurazione e sincronizza le fonti.</p>
				</v-card-text>
				<v-card-actions class="pa-3">
					<v-btn color="primary" :disabled="!caricato" :loading="sincronizzando" @click="sincronizza"><v-icon left>mdi-sync</v-icon>Sincronizza fonti</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>

		<v-col class="pa-0 px-4 mt-4" cols="12">
			<v-card elevation="1" class="background-2 round-card">
				<v-card-title class="px-3 py-2"><p class="pl-2 pl-xl-3">Mappatura dei campi</p></v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<p>Nome, cognome, email, telefono e identificativo della scheda si inviano sempre. Un valore senza traduzione non viene inviato.</p>
					<aisa-mappatura v-model="aisa.options.mapping" :catalogo="catalogo" :campi-gmh="campiGmh"></aisa-mappatura>
				</v-card-text>
				<v-card-actions class="pa-3">
					<v-spacer></v-spacer>
					<v-btn color="primary" :disabled="!caricato" :loading="salvando" @click="salva">Salva configurazione</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>

		<v-snackbar :timeout="6000" :color="snackbarColor" v-model="snackbar">
			<span class="fw500">{{ snackbarText }}</span>
			<v-btn dark text @click.native="snackbar = false">Chiudi</v-btn>
		</v-snackbar>
	</v-row>
</template>

<script>
import Vue from 'vue'
import AisaMappatura from './AisaMappatura'

const OPZIONI = { api_key: '', organization_id: '', assistant_id: '', webhook_token: '', forward_url: '', forward_token: '', blocco_reinvio_giorni: 7, mapping: [] }

export default {
	name: 'aisa',
	components: { AisaMappatura },
	props: {
		id: { type: Number, required: true },
	},
	data() {
		return {
			aisa: { active: false, options: Object.assign({}, OPZIONI) },
			catalogo: [],
			campiGmh: [],
			code: [],
			webhookUrl: '',
			caricato: false,
			verificando: false,
			salvando: false,
			generando: false,
			sincronizzando: false,
			snackbar: false,
			snackbarText: '',
			snackbarColor: 'success',
		}
	},
	created() {
		Promise.all([
			this.axios.get('integrationsapps/' + this.id),
			this.axios.get('aisa-catalogo'),
			this.axios.get('aisa-campi-gmh'),
			this.axios.get('aisa-code'),
		]).then(([integrazione, catalogo, campi, code]) => {
			this.aisa = integrazione.data.data
			if (!this.aisa.options || Array.isArray(this.aisa.options)) {
				Vue.set(this.aisa, 'options', {})
			}
			Object.keys(OPZIONI).forEach(chiave => {
				if (this.aisa.options[chiave] === undefined) {
					Vue.set(this.aisa.options, chiave, Array.isArray(OPZIONI[chiave]) ? [] : OPZIONI[chiave])
				}
			})
			this.catalogo = catalogo.data.data
			this.campiGmh = campi.data.data
			this.webhookUrl = campi.data.webhook_url
			this.code = code.data.data
			// Solo da qui si puo' salvare: con un caricamento fallito il form
			// vuoto cancellerebbe la configurazione esistente
			this.caricato = true
		}).catch(() => {
			this.avvisa('Configurazione non caricata: ricarica la pagina prima di modificarla', 'error')
		}).finally(() => {
			this.$store.commit('endProgress')
		})
	},
	methods: {
		avvisa(testo, colore) {
			this.snackbarText = testo
			this.snackbarColor = colore || 'success'
			this.snackbar = true
		},
		errore(error, ripiego) {
			this.avvisa((error.response && error.response.data && error.response.data.message) || ripiego, 'error')
		},
		salva() {
			// Il backend scarta le righe senza campo GMH o campo AISA: meglio
			// dirlo subito che farle sparire al salvataggio
			const incomplete = (this.aisa.options.mapping || []).filter(r => !r.campo || !r.aisa).length
			if (incomplete) {
				this.avvisa('Mappatura: completa o rimuovi le righe senza campo GMH o campo AISA (' + incomplete + ')', 'error')
				return
			}
			this.salvando = true
			this.axios.put('integrationsapps/' + this.id, this.aisa).then(response => {
				this.aisa.options.mapping = response.data.data.model.options.mapping || []
				this.avvisa('Configurazione salvata')
			}).catch(error => this.errore(error, 'Errore durante il salvataggio')).finally(() => {
				this.salvando = false
			})
		},
		verifica() {
			this.verificando = true
			// Si prova cio' che e' scritto qui, anche se non ancora salvato
			this.axios.post('aisa-test-connection', { options: this.aisa.options }).then(response => {
				this.avvisa('Connessione riuscita: ' + response.data.data.fonti.length + ' fonti che accettano contatti')
			}).catch(error => this.errore(error, 'Connessione non riuscita')).finally(() => {
				this.verificando = false
			})
		},
		sincronizza() {
			this.sincronizzando = true
			this.axios.post('aisa-sync-sources').then(response => {
				const e = response.data.data
				this.avvisa('Code create: ' + e.create + ', aggiornate: ' + e.aggiornate + ', non più disponibili: ' + e.non_disponibili)
				return this.axios.get('aisa-code').then(r => {
					this.code = r.data.data
				})
			}).catch(error => this.errore(error, 'Sincronizzazione non riuscita')).finally(() => {
				this.sincronizzando = false
			})
		},
		generaToken() {
			if (this.aisa.options.webhook_token && !confirm('Il token attuale smetterà di funzionare: andrà aggiornato in AISA. Continuare?')) {
				return
			}
			this.generando = true
			this.axios.post('aisa-webhook-token').then(response => {
				this.aisa.options.webhook_token = response.data.data.webhook_token
				this.webhookUrl = response.data.data.webhook_url
				this.avvisa('Token generato: copialo in AISA')
			}).catch(error => this.errore(error, 'Generazione non riuscita')).finally(() => {
				this.generando = false
			})
		},
		copia(testo) {
			if (!testo) {
				return
			}
			navigator.clipboard.writeText(testo).then(() => this.avvisa('Copiato'))
		},
		tipoFonte(kind) {
			return { hot: 'Lead caldi', cold: 'Lead freddi', dated: 'Lead programmati' }[kind] || kind
		},
	},
}
</script>
